import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-post-type"]
const _hoisted_2 = {
  key: 0,
  class: "post-inner-audio"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Open this audio by ")
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 4 }
const _hoisted_10 = {
  key: 1,
  class: "post-inner-photo"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", {
    "data-post-type": _ctx.post.type,
    class: _normalizeClass(["post masonary-item", `post-${_ctx.post.type}`])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.computedContainer), {
      to: { name: 'BlogPost', params: { id: _ctx.getPostId(_ctx.post.id) } }
    }, {
      default: _withCtx(() => [
        (_ctx.post.type === 'audio')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.post.embed)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: _ctx.post.embed
                  }, null, 8, _hoisted_3))
                : (_ctx.post['audio-player'])
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      innerHTML: _ctx.post['audio-player']
                    }, null, 8, _hoisted_4))
                  : (_ctx.post.player)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        innerHTML: _ctx.post.player
                      }, null, 8, _hoisted_5))
                    : (_ctx.post.audio_url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("a", {
                            href: _ctx.post.audio_url
                          }, "clicking here", 8, _hoisted_8)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, "Failed to load this post."))
            ]))
          : _createCommentVNode("", true),
        (_ctx.post.type === 'photo')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("img", {
                src: _ctx.post['photo-url-500']
              }, null, 8, _hoisted_11),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.photos, (photo, key) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: key,
                  src: photo['photo-url-500']
                }, null, 8, _hoisted_12))
              }), 128))
            ]))
          : (_ctx.post['regular-body'])
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "post-inner",
                innerHTML: _ctx.post['regular-body']
              }, null, 8, _hoisted_13))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["to"]))
  ], 10, _hoisted_1))
}